import type { z } from "zod";

import {
  V1ChatCompletionRequestSchema,
  V1ChatCompletionResponseSchema,
  V1CompletionResponseSchema,
  V1TextCompletionRequestSchema,
} from "./completions/completions.models";
import { EmbeddingRequestPayloadSchema } from "./embeddings/EmbeddingRequestPayload";
import { EmbeddingResponsePayloadSchema } from "./embeddings/EmbeddingResponsePayload";
import {
  V1ResponsesCreateRequestSchema,
  V1ResponsesResponseSchema,
} from "./responses/responses.models";

export const LlmInferenceRequestSchema = V1ChatCompletionRequestSchema.or(
  V1TextCompletionRequestSchema,
).or(V1ResponsesCreateRequestSchema);

export type LlmInferenceRequest = z.infer<typeof LlmInferenceRequestSchema>;

export const LlmInferenceResponseSchema = V1CompletionResponseSchema.or(
  V1ChatCompletionResponseSchema,
).or(V1ResponsesResponseSchema);

export type LlmInferenceResponse = z.infer<typeof LlmInferenceResponseSchema>;

export const GenerationRequestSchema = EmbeddingRequestPayloadSchema.or(
  LlmInferenceRequestSchema,
);

export type GenerationRequest = z.infer<typeof GenerationRequestSchema>;

export const GenerationResponseSchema = LlmInferenceResponseSchema.or(
  EmbeddingResponsePayloadSchema,
);

export type GenerationResponse = z.infer<typeof GenerationResponseSchema>;
